<div class="audio-player-container">
  <!-- Audio Controls -->
  <div class="audio-controls">
    <!-- Left: Rewind button -->
    <p-button
      icon="pi pi-step-backward"
      (onClick)="skipBackward()"
      severity="secondary"
      [text]="true"
      [rounded]="true"
      size="small"
      [disabled]="isLoading || hasError"
      i18n-pTooltip="@@convDetail.rewind5"
      pTooltip="Rewind 5 seconds"
      tooltipPosition="top"
      i18n-ariaLabel="@@convDetail.rewind5"
      ariaLabel="Rewind 5 seconds" />

    <!-- Center: Play/Pause button (medium size, circular) -->
    <p-button
      [icon]="isLoading ? 'pi pi-spin pi-spinner' : (isPlaying ? 'pi pi-pause' : 'pi pi-play')"
      (onClick)="togglePlay()"
      [rounded]="true"
      [disabled]="isLoading || hasError"
      [loading]="isLoading"
      severity="primary" />

    <!-- Right: Forward button -->
    <p-button
      icon="pi pi-step-forward"
      (onClick)="skipForward()"
      severity="secondary"
      [text]="true"
      [rounded]="true"
      size="small"
      [disabled]="isLoading || hasError"
      i18n-pTooltip="@@audioPlayer.forward5"
      pTooltip="Fast forward 5 seconds"
      tooltipPosition="top"
      i18n-ariaLabel="@@audioPlayer.forward5"
      ariaLabel="Fast forward 5 seconds" />

    <!-- Time Display -->
    <span class="time-display">{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</span>

    <!-- Download button -->
    <p-button
      icon="pi pi-download"
      [text]="true"
      [rounded]="true"
      size="small"
      (onClick)="downloadAudio()"
      i18n-pTooltip="@@audioPlayer.download"
      pTooltip="Download audio"
      tooltipPosition="top"
      i18n-ariaLabel="@@audioPlayer.download"
      ariaLabel="Download audio" />
  </div>

  <!-- Waveform (tiny audio track) -->
  <div class="waveform-container">
    <div [id]="containerId" #waveformContainer></div>
  </div>
</div>
